module.exports = "<sheet><div class=\"layout-row layout-padding\">       <text-box [fg]=\"fg\" [alt]=\"true\" field=\"filter\" leftIcon=\"search\" label=\"{{placeholder}}\"></text-box></div></sheet>";


//////////////////
// WEBPACK FOOTER
// ./src/app/inventory/shared/ui/input-filter-sheet/input-filter-sheet.component.pug
// module id = 949
// module chunks = 0